import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';

import { useMasterContext } from '../contexts/MasterContext';

import rack_1 from '../assets/rack_1.png'; // Assuming you have a rack image 

const BetaApprovalModal = ({ onUnlock }) => {
  const navigate = useNavigate();

  const { betaRequestTimestamp } = useMasterContext();

  const betaStatus = 'approved'; // Replace with actual status from context or props  
  const [countdown, setCountdown] = useState(null);

  useEffect(() => {
    if (betaStatus !== 'approved') return;

    const expiry = new Date(new Date(betaRequestTimestamp).getTime() + 24 * 60 * 60 * 1000);

    const interval = setInterval(() => {
      const now = new Date();
      const diffMs = expiry - now;

      if (diffMs <= 0) {
        clearInterval(interval);
        setCountdown('EXPIRED'); // could hide or replace with prompt
      } else {
        const hrs = Math.floor(diffMs / (1000 * 60 * 60));
        const mins = Math.floor((diffMs % (1000 * 60 * 60)) / (1000 * 60));
        const secs = Math.floor((diffMs % (1000 * 60)) / 1000);
        setCountdown(`${hrs}h ${mins}m ${secs}s`);
      }
    }, 1000);

    return () => clearInterval(interval);
  }, [betaStatus]);

  return (
    <div className="fixed inset-0 z-50 flex flex-col justify-center space-y-2 px-6 pt-8 pb-6 bg-white/70 backdrop-blur-sm animate-fade animate-delay-[1500ms]">
      
      {/* Close Button */}
      <button onClick={() => onUnlock()} class="absolute top-6 right-6 text-xs text-black font-mono">
          <svg fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="h-5 w-5 text-black">
              <path strokeLinecap="round" strokeLinejoin="round" d="m9.75 9.75 4.5 4.5m0-4.5-4.5 4.5M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z" />
          </svg>
      </button>

      {/* Notice of Closure Options */}
      <p class="absolute top-6 left-6 text-[10px] uppercase opacity-60 text-black font-mono">[Click to big round X to close]</p>
      <motion.div
        layout
        onClick={(e) => e.stopPropagation()}
        className="flex flex-col items-center w-full max-w-xl mx-auto space-y-3 border-[0.5px] border-black bg-white rounded-xl p-6"
        transition={{ duration: 0.3, ease: 'easeInOut' }}
      >
        <p className="font-mono text-xs font-bold uppercase text-left w-full">
          Welcome to the Cow Juice Private Beta Testing Program
        </p>
        <div
            className="flex w-full rounded-lg border-[0.5px] border-black transition-transform duration-500 animate-fade animate-delay-300 ease-in-out"
        >
            <img
                src={rack_1}
                alt={`Cow Juice mock‑up 1`}
                className="flex-shrink-0 w-full rounded-lg object-cover"
            />
        </div>
        <p className="font-mono text-[10px] leading-3 uppercase opacity-60 text-left w-full">
          After careful review and consideraton, you have just been approved by Cow Juice Man. Claim your spot and purchase a case before your access expires.
        </p>
        {countdown && countdown !== 'EXPIRED' && (
          <p className=" w-full text-left text-[10px] leading-3 font-mono text-black uppercase mt-2">
            <span class="opacity-60">You have </span> <span class="font-bold text-cowjuice-bronze animate-pulse">{countdown}</span> <span class="opacity-60">left to purchase before losing access.</span>
          </p>
        )}
        <button
          onClick={() => navigate('/shopify/products')}
          className="flex w-full items-center justify-center font-mono text-xs uppercase font-bold py-3 px-4 rounded-xl bg-black text-white border-[0.5px] border-black hover:bg-neutral-700 transition-colors duration-300"
        >
          Order Cow Juice Now
        </button>
        {/* <button
          onClick={() => onClose()}
          className="flex w-full items-center justify-center font-mono font-bold text-xs uppercase border-[0.5px] border-black py-3 px-4 rounded-xl"
        >
          Close
        </button> */}
      </motion.div>
    </div>
  );
};

export default BetaApprovalModal;